import React,{ useRef } from 'react';
import axios from 'axios'
import { Table, Input, Button,Collapse,Avatar,Modal,Tooltip,Form,DatePicker,Select,Space,Typography,Divider,InputNumber,message,Spin } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon, { PrinterOutlined, MinusOutlined, CloseCircleFilled, CheckCircleOutlined, UserOutlined } from '@ant-design/icons';
import { SearchOutlined,CameraOutlined,FundViewOutlined,PlusOutlined,LoadingOutlined,DownloadOutlined } from '@ant-design/icons';
import QrReader from 'react-qr-reader'
import uuid from 'react-uuid'
import PhoneInput from 'react-phone-number-input'
import moment from 'moment';
import PrintTemplate from 'react-print';
import ReactToPrint from 'react-to-print';
import * as serverconfig from '../serverconn'
import { ReportEmailControls, submitReportWithEmail, reportSearchButtonLabel, REPORT_KEYS, initialReportEmailState } from '../reportEmailUtils';
import CurrencyFormat from 'react-currency-format';
import {
  Col,
  Row,
} from 'reactstrap';
import * as reactstrp from 'reactstrap';
import ReactExport from "@ibrahimrahmani/react-export-excel";
import '../tablestyle.css'; // Create this CSS file for custom styles
import LoanSummaryList from './LoanSummaryList';

var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const { Option } = Select;
const dateFormat = 'DD/MM/YYYY';
const { Title } = Typography;
const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

const { Search } = Input;

var token= ''
var sacco= ''
var bizuserid= ''

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class ReportToPrint extends React.Component {

    state = {
    ...initialReportEmailState(),
      companyprofile:{},
    };
  
    componentDidMount(){
      if(localStorage.getItem("sacco")){
         sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
         bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
      
      }else{
         sacco= ''
         bizuserid= ''
      }
      
      if(localStorage.getItem("token")){
         token= localStorage.getItem("token")
      }else{
         token= ''
      }

      axios.defaults.headers={
        "Content-Type":"application/json",
        Authorization:`Token ${token}`
      }

      axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
      .then(res => {  
          this.setState({
            companyprofile: res.data
          })
  
      })

  
    }


   
    render() {
      return (
        <div style={{padding:20}}>
           <style>
            {`@media print {
            @page { size: landscape; }
             }`}
          </style>
       <Row> 
                <Col xs="2" sm="2" lg="2">
                <img height="100" width="120"  alt="Logo" src={this.state.companyprofile.sacco_logo} />
              
                  </Col>
                  <Col xs="6" sm="6" lg="6">
                  <h3>{this.state.companyprofile.sacco_name}</h3>
                  <h6>Tel: {this.state.companyprofile.RegisteredPhoneNumber1}
                  {
                  this.state.companyprofile.RegisteredPhoneNumber2==""?
                  "":","+this.state.companyprofile.RegisteredPhoneNumber2
                  }
                  {
                  this.state.companyprofile.RegisteredPhoneNumber3==""?
                  "":","+this.state.companyprofile.RegisteredPhoneNumber3
                  }
                  </h6>               
                  <h5>Email: {this.state.companyprofile.company_email}</h5>
                  <h5>Wesite: {this.state.companyprofile.website}</h5>
                  <h5>{this.state.companyprofile.box_number}</h5>
                
                  </Col>
       </Row>

             <h3 style={{display: 'flex',justifyContent:'center', alignItems:'center',fontWeight:'bolder'}}>LOAN AGING REPORT AS OF {this.props.date} </h3>
            
             <reactstrp.Table bordered>
                        <thead>
                          <tr>
                            <th>Loan number</th>
                            <th>Account Name</th>
                            <th>Account Number</th>
                            <th>Issuance Date</th>
                            <th>Loan Amount</th>
                            <th>Arears</th>
                            <th>Outstanding Balance</th>
                            <th>Maturity Date</th>
                            <th>(0-29) Days</th>
                            <th>(30-89) Days</th>
                            <th>(90-179) Days</th>
                            <th>(180-364) Days</th>
                            <th> 365 & Above Days</th>
                          </tr>
                        </thead>
                        <tbody>
                        {this.props.loanissues.map(
                          (item)=>(
                            <tr>
                            <td>{item.loan_number}</td>
                            <td>{item.account_number}</td>
                            <td>{item.account_name}</td>
                            <td>{item.loan_date}</td>
                            <td className="align-right">{<CurrencyFormat value={item.total_loan_amount} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td className="align-right">{<CurrencyFormat value={item.arrears} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td className="align-right">{<CurrencyFormat value={item.outstanding_balance} displayType={'text'} thousandSeparator={true}/>}</td>                            
                            <td>{item.expiry}</td>

                            <td className="align-right">{<CurrencyFormat value={item.days_0_29} displayType={'text'} thousandSeparator={true}/>}</td>                            
                            <td className="align-right">{<CurrencyFormat value={item.days_30_89} displayType={'text'} thousandSeparator={true}/>}</td>                            
                            <td className="align-right">{<CurrencyFormat value={item.days_90_179} displayType={'text'} thousandSeparator={true}/>}</td>                            
                            <td className="align-right">{<CurrencyFormat value={item.days_180_364} displayType={'text'} thousandSeparator={true}/>}</td>                            
                            <td className="align-right">{<CurrencyFormat value={item.days_365_455} displayType={'text'} thousandSeparator={true}/>}</td>                            

                            </tr>
                          ))}
                          <tr>
                          <td style={{fontWeight:'bolder'}}>Totals</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>

                          <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.props.totalsaggregate.totaldays_0_29} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.props.totalsaggregate.totaldays_30_89} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.props.totalsaggregate.totaldays_90_179} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.props.totalsaggregate.totaldays_180_364} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.props.totalsaggregate.totaldays_365_455} displayType={'text'} thousandSeparator={true}/>}</td>
                          </tr>

                          <tr>
                          <td style={{fontWeight:'bolder'}}>Risk</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>

                          <td className="align-right"style={{fontWeight:'bolder'}}>{this.props.risk_dict.percentageOne}</td>
                          <td className="align-right"style={{fontWeight:'bolder'}}>{this.props.risk_dict.percentageTwo}</td>
                          <td className="align-right"style={{fontWeight:'bolder'}}>{this.props.risk_dict.percentageThree}</td>
                          <td className="align-right"style={{fontWeight:'bolder'}}>{this.props.risk_dict.percentageFour}</td>
                          <td className="align-right"style={{fontWeight:'bolder'}}>{this.props.risk_dict.percentageFive}</td>
                          </tr>


                          <tr>
                          <td className="align-right"style={{fontWeight:'bolder'}}>
                          <h4>Total risk: {<CurrencyFormat value={this.props.totalRiskAmount} displayType={'text'} thousandSeparator={true}/>}</h4>

                          </td>
                          <td className="align-right">
                          <h4>Portfolio total: {<CurrencyFormat value={this.props.portifoliototal} displayType={'text'} thousandSeparator={true}/>}</h4>

                          </td>
                          <td className="align-right">
                          <h4>Percentage off portifolio: {<CurrencyFormat value={this.props.percentageoff_portfolio.toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</h4>

                          </td>
                          <td>

                          </td>
                          <td></td>

                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>

                          <td style={{fontWeight:'bolder'}}></td>

                          </tr>
                          
                      </tbody>
                  </reactstrp.Table>       
           
                  <br></br>
                <h3>Generated by: {CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)}</h3>
                <h3>Powered by: www.pitech.co.ug</h3>   

        </div>
      );
    }
  }


class LoanAgingReport extends React.Component {

  state = {
    ...initialReportEmailState(),
    loanissues:[],
    //date:moment().format(dateFormat).toString(),
    datarequested:true,
    totalsaggregate:{},
    totalRiskAmount:0,
    percentageoff_portfolio:0,
    portifoliototal:0,
    loanissues_placeholder:[],

    date:moment().format(dateFormat).toString(),
    show_details:false,
    selected_id:0,
    risk_dict:{},
    companyprofile: {},

   };

  loadReport = () => {
    if (this.state.date === '') {
      alert('Date missing');
      return;
    }

    this.setState({ loanissues: [] });
    const form_data = new FormData();
    form_data.append('sacco', sacco);
    form_data.append('date', this.state.date);

    submitReportWithEmail({
      reportKey: REPORT_KEYS.LOAN_AGING,
      params: { sacco, date: this.state.date },
      emailReport: this.state.email_report,
      receivingEmail: this.state.receiving_email,
      endpoint: serverconfig.backendserverurl + '/customqueries/getLoanAgingReport',
      formData: form_data,
      setLoading: (v) => this.setState({ datarequested: v }),
      onSuccess: (res) => {
        this.setState({
          loanissues: JSON.parse(res.data.loanissues),
          totalsaggregate: JSON.parse(res.data.loanissuesaggregate),
          totalRiskAmount: res.data.totalRisk,
          portifoliototal: res.data.portifoliototal,
          percentageoff_portfolio: res.data.percentageoff_portfolio,
          loanissues_placeholder: JSON.parse(res.data.loanissues),
          risk_dict: res.data.risk_dict,
        });
      },
    });
  };

   componentDidMount(){
    if(localStorage.getItem("sacco")){
      sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
      bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
   
   }else{
      sacco= ''
      bizuserid= ''
   }
   
   if(localStorage.getItem("token")){
      token= localStorage.getItem("token")
   }else{
      token= ''
   }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {
      this.setState((prev) => ({
        companyprofile: res.data,
        receiving_email: prev.receiving_email || res.data.company_email || '',
      }));
    });

    this.loadReport();

  }
 

   ////////////////////////////////////
  // USER SEARCH SELECT METHODS
  onBlur=()=> {
    console.log('blur');
  }
  
   onFocus=()=>{
    console.log('focus');
  }
  
  onSearch=(val)=> {
    console.log('search:', val);
  }
 

   ////////////////////////////////////////////
   // RENDERING METHOD HERE
   render() {

       if(this.state.datarequested===true){
        return(
          <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin size="large">
                <div className="content" />
              </Spin>             </div>
        )
  
      }else{

        return(
          <div>
            <div style={{display: "none",}}>
               &nbsp;&nbsp;
              <ReportToPrint
              date={this.state.date} 
              loanissues={this.state.loanissues} 
              totalsaggregate={this.state.totalsaggregate} 
              totalRiskAmount={this.state.totalRiskAmount} 
              percentageoff_portfolio={this.state.percentageoff_portfolio} 
              portifoliototal={this.state.portifoliototal} 
              risk_dict={this.state.risk_dict} 

              ref={el => (this.componentRef = el)} /> 
            </div>
  
            <Collapse defaultActiveKey={['1']} onChange={this.callback}>
              <Panel header="LOAN AGING REPORT" key="1">
           
              <div style={{display:'flex',justifyContent:'flex-start',alignSelf:'flex-start',alignItems:'flex-start'}}>
              {!this.state.email_report ? (
              <>
              <ReactToPrint
                  trigger={() => 
                  <Button type="primary"  shape="round" icon={<PrinterOutlined />} size={this.state.size}>
                  Print
                  </Button>
                  }
                  content={() => this.componentRef}
                  />


              &nbsp;&nbsp;&nbsp;
              <ExcelFile filename={"Pisacco - loan aging report by "+this.state.date}  element={<Button type='primary' icon={<DownloadOutlined/>}>Download report (Excel)</Button>}>
                <ExcelSheet data={this.state.loanissues} name="Loan aging report">
                    <ExcelColumn label="#" value="item_no"/>

                    <ExcelColumn label="Loan number" value="loan_number"/>
                    <ExcelColumn label="Account name" value="account_name"/>
                    <ExcelColumn label="Account number" value="account_number"/>
                    <ExcelColumn label="Issuance date" value="loan_date"/>
                    <ExcelColumn label="Loan Amount" value="total_loan_amount"/>
                    
                    <ExcelColumn label="Arrears" value="arrears"/>
                    <ExcelColumn label="Outstanding Balance" value="outstanding_balance"/>
                   
                    <ExcelColumn label="Maturity Date" value="expiry"/>

                    <ExcelColumn label="(0-29) Days" value="days_0_29"/>

                    <ExcelColumn label="(30-89) Days" value="days_30_89"/>
                    <ExcelColumn label="(90-179) Days" value="days_90_179"/>

                    <ExcelColumn label="(180-364) Days" value="days_180_364"/>
                    <ExcelColumn label="365 & Above Days" value="days_365_455"/>

                </ExcelSheet>
               </ExcelFile>
               &nbsp;&nbsp;&nbsp;
              </>
              ) : null}

               <Form  layout="inline" >
              
              <FormItem label="Aging by (Date)">
                  <DatePicker 
                   onChange={(date, dateString) =>{
                      this.setState({ date: dateString});
                    }} format={dateFormat} />
              </FormItem>


            <ReportEmailControls
              emailReport={this.state.email_report}
              receivingEmail={this.state.receiving_email}
              onEmailReportChange={(val) => this.setState({ email_report: val })}
              onReceivingEmailChange={(val) => this.setState({ receiving_email: val })}
              companyEmail={this.state.companyprofile.company_email}
            />

            <FormItem>
            <Button onClick={this.loadReport} type="primary" htmlType="button">{reportSearchButtonLabel(this.state.email_report)}</Button>
            </FormItem> 

            </Form>

              </div>  
              <br></br>

            <div style={{overflowX:'auto'}}>

             <Search
             placeholder="Input Account number or Account name"
             onChange={(value) => {
              var val=value.target.value
              console.log(val)
              if (val !== '') {
                const results = this.state.loanissues.filter((request) => {
                  return request.account_name.toLowerCase().startsWith(val.toLowerCase());
                  // Use the toLowerCase() method to make it case-insensitive
                });
          
                if (results.length === 0) {
                  // this.setState({loanissues:this.state.loanissues_placeholder});

                  const results_2 = this.state.loanissues.filter((request) => {
                    return request.account_number.toLowerCase().startsWith(val.toLowerCase());
                    // Use the toLowerCase() method to make it case-insensitive
                  });

                  if (results_2.length === 0) {
                    this.setState({loanissues:this.state.loanissues_placeholder});

                  }else{
                    this.setState({loanissues:results_2});

                  }

                } else {
                  this.setState({loanissues:results});
                  console.log(results)
                }
          
              } else {
                this.setState({loanissues:this.state.loanissues_placeholder});
          
              }
          
            }}
            style={{
              width: 400,
            }}
            />
            <br></br>
            <br></br>


              <reactstrp.Table bordered>
                        <thead>
                          <tr>
                          <th>Details</th>

                           <th>No</th>
                            <th>Loan number</th>
                            <th>Account Name</th>
                            <th>Account Number</th>
                            <th>Issuance Date</th>
                            <th>Loan Amount</th>
                            <th>Arears</th>
                            <th>Outstanding Balance</th>
                            <th>Maturity Date</th>
                            <th>(0-29) Days</th>
                            <th>(30-89) Days</th>
                            <th>(90-179) Days</th>
                            <th>(180-364) Days</th>
                            <th> 365 & Above Days</th>
                          </tr>
                        </thead>
                        <tbody>
                        {this.state.loanissues.map(
                          (item)=>(
                            <React.Fragment>
                              <tr>

                            <td>
                            <Tooltip title="Click view loan details" placement="top">
                            <FundViewOutlined style={{color:'blue'}}
                              onClick={()=>{
                                console.log("ID: "+String(item.id))
                                this.setState({selected_id:Number(item.id)})
                                this.setState({show_details:!this.state.show_details})
                            }}
                            />
                            </Tooltip>
                            </td>

                            <td>{item.item_no}</td>
                            <td>{item.loan_number}</td>
                            <td>{item.account_number}</td>
                            <td>{item.account_name}</td>
                            <td>{item.loan_date}</td>
                            <td className="align-right">{<CurrencyFormat value={item.total_loan_amount} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td className="align-right">{<CurrencyFormat value={item.arrears} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td className="align-right">{<CurrencyFormat value={item.outstanding_balance} displayType={'text'} thousandSeparator={true}/>}</td>                            
                            <td>{item.expiry}</td>
                            <td className="align-right">{<CurrencyFormat value={item.days_0_29} displayType={'text'} thousandSeparator={true}/>}</td>                            
                            <td className="align-right">{<CurrencyFormat value={item.days_30_89} displayType={'text'} thousandSeparator={true}/>}</td>                            
                            <td className="align-right">{<CurrencyFormat value={item.days_90_179} displayType={'text'} thousandSeparator={true}/>}</td>                            
                            <td className="align-right">{<CurrencyFormat value={item.days_180_364} displayType={'text'} thousandSeparator={true}/>}</td>                            
                            <td className="align-right">{<CurrencyFormat value={item.days_365_455} displayType={'text'} thousandSeparator={true}/>}</td>                            

                            </tr>


                              {
                               this.state.show_details===true && Number(this.state.selected_id)===Number(item.id)?
                               <tr >
                                <td colSpan={16}>
                                  {/* Your expanded content goes here */}
                                  <div>
                                    
                                    {
                                    this.state.show_details===true?
                                    <LoanSummaryList loan_id={item.id} />
                                    :
                                    null
                                    }

                                  </div>
                                </td>

                              </tr>
                              :
                              null
                            }


                            </React.Fragment>
                            
                          
                          ))}

                          
                          <tr>
                          <td style={{fontWeight:'bolder'}}>Totals</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>

                          <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.state.totalsaggregate.totaldays_0_29} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.state.totalsaggregate.totaldays_30_89} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.state.totalsaggregate.totaldays_90_179} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.state.totalsaggregate.totaldays_180_364} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.state.totalsaggregate.totaldays_365_455} displayType={'text'} thousandSeparator={true}/>}</td>
                         
                          </tr>


                          <tr>
                          <td style={{fontWeight:'bolder'}}>Risk</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>

                          <td className="align-right"style={{fontWeight:'bolder'}}>{this.state.risk_dict.percentageOne}</td>
                          <td className="align-right"style={{fontWeight:'bolder'}}>{this.state.risk_dict.percentageTwo}</td>
                          <td className="align-right"style={{fontWeight:'bolder'}}>{this.state.risk_dict.percentageThree}</td>
                          <td className="align-right"style={{fontWeight:'bolder'}}>{this.state.risk_dict.percentageFour}</td>
                          <td className="align-right"style={{fontWeight:'bolder'}}>{this.state.risk_dict.percentageFive}</td>
                          </tr>


                          <tr>
                          <td className="align-right"style={{fontWeight:'bolder'}}>
                          <h4>Total risk: {<CurrencyFormat value={this.state.totalRiskAmount} displayType={'text'} thousandSeparator={true}/>}</h4>

                          </td>
                          <td className="align-right">
                          <h4>Portfolio total: {<CurrencyFormat value={this.state.portifoliototal} displayType={'text'} thousandSeparator={true}/>}</h4>

                          </td>
                          <td className="align-right">
                          <h4>Percentage off portifolio: {<CurrencyFormat value={this.state.percentageoff_portfolio.toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</h4>

                          </td>
                          <td>

                          </td>
                          <td></td>
                          <td></td>
                          <td></td>

                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>

                          <td style={{fontWeight:'bolder'}}></td>

                          </tr>
                          
                      </tbody>
                  </reactstrp.Table>      
                </div>
                   
              <br></br>

              </Panel>
              </Collapse>

             </div>
  
      )}
   
   }
}

export default LoanAgingReport; 
